module.exports = __webpack_public_path__ + "images/index/img04.1603fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/kuang/img04.jpg
// module id = r9vP
// module chunks = 21